'use client';

import CustomLoading from '@/components/custom-loading';
import { useLoadingStore } from '@/hooks/use-loading-store';
import { Fragment, memo } from 'react';

/**
 * Loading toàn bộ APP
 */
const CustomAppLoading = () => {
    const { isAppLoading } = useLoadingStore();

    if (isAppLoading) {
        return (
            <div id='app-loading' className='fixed inset-0 z-50'>
                <div className='absolute inset-0 bg-gray-700 opacity-40'></div>

                <div className='absolute inset-0 flex items-center justify-center text-primary-foreground'>
                    <CustomLoading.Wifi />
                </div>
            </div>
        );
    }

    return <Fragment />;
};

export default memo(CustomAppLoading);
